<template>
	<v-main>
		
        <!-- <v-container style="padding: 64px 0px 0px 256px;"> -->
        <v-container>
			<!-- <div v-html="outputHtml"></div> -->
			<v-card flat>
				<!-- <v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title> -->
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<!-- <v-card-text v-html="outputHtml">
				</v-card-text> -->
				<v-card-text>
					<v-expansion-panels v-model="panel" multiple>
						<v-expansion-panel>
							<v-expansion-panel-header>Огляд</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row :dense="dense">
									<v-col cols="12" md="2">
										<!-- <v-menu
											v-model="menu.date"
											:close-on-content-click="false"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="auto"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="item.date"
													label="Дата"
													prepend-icon="mdi-calendar"
													readonly
													v-bind="attrs"
													v-on="on"
												></v-text-field>
											</template>
											<v-date-picker v-model="item.date" @input="menu.date = false"></v-date-picker>
										</v-menu> -->
										<v-text-field
											v-model="item.date"
											label="Дата"
											type="date"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<!-- <v-menu
											ref="menu"
											v-model="menu.time"
											:close-on-content-click="false"
											:nudge-right="40"
											:return-value.sync="time"
											transition="scale-transition"
											offset-y
											max-width="290px"
											min-width="290px"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="item.time"
													label="Picker in menu"
													prepend-icon="mdi-clock-time-four-outline"
													readonly
													v-bind="attrs"
													v-on="on"
												></v-text-field>
											</template>
											<v-time-picker
												v-if="menu.time"
												v-model="item.time"
												full-width		
											></v-time-picker>
										</v-menu> -->
										<v-text-field
											v-model="item.time"
											label="Label Text"
											type="time"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="8">
										<v-text-field
											label="Місце"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-text-field
											label="Акт складено"
											placeholder="П.І.Б., посада"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
								</v-row>
							<!-- Дата, час огляду
							Місце огляду
							Дата пошкоджень
							Акт складено (П.І.Б., посада) -->
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Подія</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row :dense="dense">
									<v-col cols="12" md="2">
										<v-text-field
											v-model="item.event.date"
											label="Дата"
											type="date"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<v-text-field
											v-model="item.event.time"
											label="Час"
											type="time"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="8">
										<v-text-field
											v-model="item.event.place"
											label="Місце"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Власник (Довірена особа)</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row :dense="dense">
									<v-col cols="12">
										<v-text-field
											v-model="item.owner.name"
											label="П.І.Б."
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="8">
										<v-text-field
											v-model="item.owner.address"
											label="Адреса"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="4">
										<v-text-field
											v-model="item.owner.phone"
											label="Телефон"
											:outlined="outlined"
											:dense="dense"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel>
							<v-expansion-panel-header>Транспортний засіб</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row :dense="dense">
									<v-col cols="12" md="2">
										<v-text-field
											v-model.trim="item.vehicle.number"
											label="Державний номер"
											:outlined="outlined"
											:dense="dense"
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<v-text-field
											v-model.trim="item.vehicle.vin"
											label="VIN-код (№ кузова)"
											:outlined="outlined"
											:dense="dense"
											clearable
											hide-details="auto"
										></v-text-field>
									</v-col>
									<!-- Vehicle Registration Certificate (VRC) -->
									
								</v-row>

								<v-card flat>
									<v-card-title>
										<v-icon large left>mdi-certificate</v-icon>
										<span class="text-h6 font-weight-light">Свідоцтво про реєстрацію</span>
									</v-card-title>
									<v-card-text>
										<v-row :dense="dense">
											<v-col cols="12" md="2">
												<v-text-field
													v-model.trim="item.vehicle.vrc.number"
													label="Серія і номер"
													:outlined="outlined"
													:dense="dense"
													clearable
													hide-details="auto"
												></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<v-text-field
													v-model="item.vehicle.vrc.date"
													label="Дата"
													type="date"
													:outlined="outlined"
													dense
												></v-text-field>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>

								<!-- <v-divider></v-divider>
								<h5>Свідоцтво про реєстрацію КТЗ</h5> --> 

								<v-row :dense="dense">
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.category"
											:items="categories"
											label="Категорія"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="[rules.required]"
											@change="onCategory"
											@focus="loadCategories"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.brand"
											:items="brands"
											label="Марка"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="[rules.required]"
											@change="onBrand"
											@focus="loadBrands"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.model"
											:items="models"
											label="Модель"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											:rules="modelRules"
											@change="onModel"
											@focus="loadModels"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.yearProd"
											:items="years"
											label="Рік випуску авто"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
											:rules="[rules.required]"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.bodystyle"
											:items="bodystyles"
											label="Тип кузова"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											@focus="loadBodystyles"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.driver"
											:items="drivers"
											label="Тип приводу"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											@focus="loadDrivers"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-text-field
											v-model="item.vehicle.engineVolume"
											label="Об'єм двигуна, л."
											:outlined="outlined"
											:dense="dense"
											type="number"
											hide-details="auto"
											:min="minEngineVolume"
											:max="maxEngineVolume"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.fuel"
											:items="fuels"
											label="Тип палива"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											@focus="loadFuels"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.gearbox"
											:items="gearboxes"
											label="Коробка передач"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											@focus="loadGearboxes"
										></v-combobox>
									</v-col>
									<v-col cols="12" md="2">
										<v-combobox
											v-model="item.vehicle.color"
											:items="colors"
											label="Колір"
											:outlined="outlined"
											:dense="dense"
											item-text="name"
											item-value="id"
											hide-details="auto"
											@focus="loadColors"
										></v-combobox>
									</v-col>
								</v-row>
								
								<v-card flat>
									<v-card-title>
										<v-icon large left>mdi-tire</v-icon>
										<span class="text-h6 font-weight-light">Шини</span>
									</v-card-title>
									<v-card-text>
										<v-row :dense="dense">
											<v-col cols="12" md="2">
												<v-text-field
													label="Марка"
													v-model.trim="item.vehicle.tire.brand"
													:outlined="outlined"
													:dense="dense"
													clearable
													hide-details="auto"
												></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<v-text-field
													label="Марка"
													v-model.trim="item.vehicle.tire.model"
													:outlined="outlined"
													:dense="dense"
													clearable
													hide-details="auto"
												></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<v-text-field
													label="Розмір"
													v-model.trim="item.vehicle.tire.size"
													:outlined="outlined"
													:dense="dense"
													clearable
													hide-details="auto"
												></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<v-combobox
													v-model="item.vehicle.tire.type"
													:items="tiretypes"
													label="Тип"
													:outlined="outlined"
													:dense="dense"
													item-text="name"
													item-value="id"
													hide-details="auto"
												></v-combobox>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							<!-- Державний номер
							Vin-code (№ кузова)
							Свідоцтво про реєстрацію КТЗ
								Серія і номер
								Дата видачі
							
							Тип КТЗ | Категорія
							Марка
							Модель
							Рік випуску
							Тип кузова
							Колір
							Пробіг, км
							Двигун V, см3
							Паливо

							Шини 
								Марка
								модель
								Розмір
								Тип (літня, зимова, всесезонна) tiretypes-->
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Комплектація</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row :dense="dense">
									<v-col cols="12" md="3">
										<p>Комплектація КТЗ:</p>
										<v-checkbox
											v-model="item.vehicle.equipment.base"
											label="базова"
											:outlined="outlined"
											:dense="dense"
										></v-checkbox>
									</v-col>
									<v-col cols="12" md="3">
										<p>КТЗ укомплектовано:</p>
										<v-radio-group v-model="item.vehicle.equipped" mandatory row>
											<v-radio label="так" :value="true"></v-radio>
											<v-radio label="ні" :value="false"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="3">
										<p>Автомобіль:</p>
										<v-radio-group v-model="item.vehicle.running" mandatory row>
											<v-radio label="на ходу" :value="true"></v-radio>
											<v-radio label="не на ходу" :value="false"></v-radio>
										</v-radio-group>
									</v-col>
									<v-col cols="12" md="3">
										<p>Додаткове обладнання:</p>
										<v-radio-group v-model="item.vehicle.extra" mandatory row>
											<v-radio label="є" :value="true"></v-radio>
											<v-radio label="нема" :value="false"></v-radio>
										</v-radio-group>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="3">
										<v-checkbox
											v-model="item.vehicle.equipment.has_abs"
											label="Антиблокувальна система (ABS)"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_towing"
											label="тягово-зачіпний пристрій"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_transmission_automatic"
											label="автоматична КПП"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.computer"
											label="бортовий комп'ютер"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_airbag_driver"
											label="подушка безпеки водія"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_airbag_passenger"
											label="подушка безпеки пасажира"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_airbag_side"
											label="подушка безпеки бокова"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_tinted_glass"
											label="тоновані стекла"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_alarm_antitheft"
											label="протиугіння сигналізація"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_asr"
											label="ASR (противобукс система)"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
									</v-col>
									<v-col cols="12" md="3">
										<v-checkbox
											v-model="item.vehicle.equipment.has_roofrails"
											label="релінги на даху"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_alloy_wheels"
											label="легкосплавні диски"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_power_windows_electric_front"
											label="електр. склопіднімачі. п."
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_power_windows_electric_back"
											label="електр. склопіднімачі. з."
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_transmission_manual"
											label="() мех. КПП"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_headlights_additional"
											label="додаткові фари"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_wiper_rear"
											label="склоочісник задній"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_climate_control"
											label="клімат-контроль"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_conditioner"
											label="кондиціонер"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_headrests"
											label="підголовники"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
									</v-col>
									<v-col cols="12" md="3">
										<v-checkbox
											v-model="item.vehicle.equipment.has_navigation"
											label="навігаційна система"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_leather_artificial"
											label="штучна шкіра"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_leather_genuine"
											label="натуральна шкіра"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_velour"
											label="велюр"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_сarradio"
											label="а/магнітола"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_seats_rear_split"
											label="роздільні зад. сидіння"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_headlight_washer"
											label="омивач фар"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_sunroof"
											label="люк скляний"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_sunroof_drive_manual"
											label="механіч. зруш. люк"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_sunroof_drive_electric"
											label="електр. зруш. люк"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
									</v-col>
									<v-col cols="12" md="3">
										<v-checkbox
											v-model="item.vehicle.equipment.has_cruise_control"
											label="електр. зруш. люк"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_thermometer_outdoor"
											label="зовнішній термометр"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_antitheft"
											label="протиугінний пристрій"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_central_lock"
											label="центральний замок"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_xenon_light"
											label="ксеонове світло"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_headlight_corrector"
											label="коректор фар"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_player_cd"
											label="CD програвач"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_gas_installation"
											label="газова установка"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
										<v-checkbox
											v-model="item.vehicle.equipment.has_bumper_in_car_color"
											label="бампер у колір авто"
											:outlined="outlined"
											:dense="dense"
											hide-details="auto"
										></v-checkbox>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Пошкодження</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									:headers="header.vehicle.part.damages"
									:items="item.vehicle.parts"
								>
									<template v-slot:top>
									<v-toolbar flat>
										<v-toolbar-title>Деталі та характер їх пошкодження</v-toolbar-title>
										<v-spacer></v-spacer>

										<z-vehicle-part-damage>
											<template v-slot:activator="props">
												<v-btn v-bind="props.attrs" v-on="props.dialog" color="primary" dark class="mb-2">
													<v-icon>mdi-plus</v-icon>
													Додати
												</v-btn>

												<!-- <v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
													<v-icon>mdi-pencil</v-icon>
												</v-btn> -->
											</template>
										</z-vehicle-part-damage>
										<!-- <v-btn color="primary" dark class="mb-2">
											Додати
										</v-btn> -->
										<!-- <v-dialog
										v-model="dialog"
										max-width="500px"
										>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
											color="primary"
											dark
											class="mb-2"
											v-bind="attrs"
											v-on="on"
											>
											New Item
											</v-btn>
										</template>
										<v-card>
											<v-card-title>
											<span class="text-h5">{{ formTitle }}</span>
											</v-card-title>

											<v-card-text>
											<v-container>
												<v-row>
												<v-col
													cols="12"
													sm="6"
													md="4"
												>
													<v-text-field
													v-model="editedItem.name"
													label="Dessert name"
													></v-text-field>
												</v-col>
												<v-col
													cols="12"
													sm="6"
													md="4"
												>
													<v-text-field
													v-model="editedItem.calories"
													label="Calories"
													></v-text-field>
												</v-col>
												<v-col
													cols="12"
													sm="6"
													md="4"
												>
													<v-text-field
													v-model="editedItem.fat"
													label="Fat (g)"
													></v-text-field>
												</v-col>
												<v-col
													cols="12"
													sm="6"
													md="4"
												>
													<v-text-field
													v-model="editedItem.carbs"
													label="Carbs (g)"
													></v-text-field>
												</v-col>
												<v-col
													cols="12"
													sm="6"
													md="4"
												>
													<v-text-field
													v-model="editedItem.protein"
													label="Protein (g)"
													></v-text-field>
												</v-col>
												</v-row>
											</v-container>
											</v-card-text>

											<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn
												color="blue darken-1"
												text
												@click="close"
											>
												Cancel
											</v-btn>
											<v-btn
												color="blue darken-1"
												text
												@click="save"
											>
												Save
											</v-btn>
											</v-card-actions>
										</v-card>
										</v-dialog> -->
										<!-- <v-dialog v-model="dialogDelete" max-width="500px">
										<v-card>
											<v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
											<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
											<v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
											<v-spacer></v-spacer>
											</v-card-actions>
										</v-card>
										</v-dialog> -->
									</v-toolbar>
									</template>
									<template v-slot:item.actions="{ item }">
									<v-icon
										small
										class="mr-2"
										@click="editItem(item)"
									>
										mdi-pencil
									</v-icon>
									<v-icon
										small
										@click="deleteItem(item)"
									>
										mdi-delete
									</v-icon>
									</template>
									<template v-slot:no-data>
									<v-btn
										color="primary"
										@click="initialize"
									>
										Reset
									</v-btn>
									</template>
								</v-data-table>


								Корозійні пошкодження (текст)
								Наявність слідів відновлювального ремонту. Їх кількість
								Пошкодження ЛФП
								Пошкодження скла

								Наявність вузлів і агрегатів, що потребують ремонту
								Оббивка салону - пошкодження та потертості
								Оббивка сидінь - пошкодження та потертості
								Експлуатація в режимі таксі
								КТЗ спеціалізованого призначення

								Пошкодження, які не стосуються даної Події (checkbox)
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Дефекти</v-expansion-panel-header>
							<v-expansion-panel-content>
								
							</v-expansion-panel-content>
						</v-expansion-panel>

						

						<v-expansion-panel>
							<v-expansion-panel-header>Деталі та характер їх пошкодження</v-expansion-panel-header>
							<v-expansion-panel-content>
								Найменування деталі
								характер пошкодження (тріщина, залом, зміщення, розрив, згин, вм'ятина, випуклість, подряпина, скол, відшатування, потертість)
								вид
								Місце
								Плоша деформації
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header>Фото</v-expansion-panel-header>
							<v-expansion-panel-content>
								<!-- <v-card v-for="(image, index) in images" :key="index"
									class="portrait"
									:img="image.src"
									height="300"
									width="300"
								>
							
								</v-card> -->
								<v-row>
									<v-col v-for="(image, index) in images" :key="index"
										class="d-flex child-flex"
										cols="4"
									>
										<v-card
											class="d-flex justify-center align-center mb-6"
											height="300"
										>
											<!-- <div class="overflow-hidden" style="width: 100px; height: 100px;">
												<v-img
													:src="image.src"
													cover
												></v-img>
											</div> -->

											<!-- <v-img
												:src="image.src"
												max-width="100"
												max-height="100"
												cover
											></v-img> -->
											<!-- <v-img
												:src="image.src"
												width="100"
												height="100"
												cover
												style="object-position: right center;"
											></v-img> -->

											<!-- <v-img
												:src="image.src"
												:max-width="frameWidth"
												:max-height="frameHeight"
												cover
												:style="getPosition(1,1)"
											></v-img> -->

											<!-- <v-img
												:src="image.src"
												max-width="100"
												max-height="100"
												cover
											> -->
											
											<!-- contain -->
												<!-- <v-app-bar flat color="rgba(0, 0, 0, 0)">
													<v-app-bar-nav-icon color="white"></v-app-bar-nav-icon>

													<v-toolbar-title class="text-h6 white--text pl-0">
													Messages
													</v-toolbar-title>

													<v-spacer></v-spacer>

													<v-btn color="white" icon>
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</v-app-bar> -->
											<!-- </v-img> -->

											<!-- <v-card-title class="text-h6">{{ image.title }}</v-card-title>
											<v-card-text class="text-center">
												
											</v-card-text> -->
										</v-card>
										<!-- 
										aspect-ratio="1"
												class="grey lighten-2"
										width="300"
										:img="image.src" -->
										<!-- <v-img
											:src="image.src"
											:lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
											aspect-ratio="1"
											class="grey lighten-2"
											height="100"
											width="100"
											:style="{
												'background-position': '50% 20%', // Зміщення по X та Y (наприклад, '50% 20%')
												'background-size': 'cover', // Або 'contain', '100% 100%', 'auto 100%'
												'background-repeat': 'no-repeat' // Щоб уникнути повторення
											}"
										>
											<template v-slot:placeholder>
												<v-row
													class="fill-height ma-0"
													align="center"
													justify="center"
												>
													<v-progress-circular
													indeterminate
													color="grey lighten-5"
													></v-progress-circular>
												</v-row>
											</template>
										</v-img> -->
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<!-- <v-expansion-panel>
							<v-expansion-panel-header>Panel 3</v-expansion-panel-header>
							<v-expansion-panel-content>
							Some content
							</v-expansion-panel-content>
						</v-expansion-panel> -->
					</v-expansion-panels>
				</v-card-text>

				<v-card flat>
					<!-- <v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title> -->
					<!-- <v-card-title class="text-h5">{{ title }}</v-card-title> -->
					<!-- <v-card-subtitle>{{ subtitle }}</v-card-subtitle> -->
					<!-- <v-divider></v-divider> -->
					<v-card-text v-html="outputHtml">
					</v-card-text>
				</v-card>

			</v-card>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-file-input
			v-model="file"
			ref="fileinput"
			class="d-none"
			multiple
			accept="image/png;image/jpeg;image/webp;image/heic;image/heif"
			@change="changeFile"
		></v-file-input>
    </v-main>
</template>

<script>
import axios from 'axios'
//import mixin from './mixin/main'
import mixin from './mixin/parameters'
import { mapGetters, mapActions } from 'vuex'
import zPdf from '@/views/pdf/VehicleInspectionAct'
//import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
//import zVehicleParameters from '@/views/forms/vehicle.parameters.showroom'
//import zParameters from '@/views/forms/parameters/VehicleEstimateAI'

//import { GoogleGenAI } from "@google/genai";
//import DOMPurify from 'dompurify';
//import { marked } from "https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js";
//import { marked } from 'marked';
//import { markdownit } from 'markdown-it';
//import VueMarkdown from 'vue-markdown-render'
//import VueMarkdown from 'vue-markdown-v2';
//import { Vue2MarkdownIt  } from 'vue2-markdown-it'

//import VueMarked from 'vue-marked';

//import { marked } from 'marked';
//import marked from 'marked';

import zVehiclePartDamage from '@/views/dialogs/details/VehiclePartDamage'



/* import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete' */

export default {
	name: 'VehicleInspectionAct',
	mixins: [mixin],
	components: {
		zPdf,
		zVehiclePartDamage
	},
	data: () => ({
		title: 'Акт огляду',
		subtitle: 'Складається на підставі зовнішнього огляду ТЗ',
		icon: 'mdi-car-select',
		loading: false,

		panel: [0,1,2,3,4,5,6,7,8,9],

		menu: {
			date: false,
			time: false
 		},

		//:headers="header.vehicle.parts"
		//:items="item.parts"

		item: {
			event: {},
			owner: {},
			vehicle: {
				vrc: {},
				tire: {},
				equipment: {},
				parts: [],
			},
			
		},

		header: {
			vehicle: {
				part: {
					damages: [
						//{ text: 'ID', value: 'id', align: ' d-none' },
						{ text: 'ID', value: 'id', sortable: true},
						{ text: 'Код', value: 'code', sortable: true},
						{ text: 'Назва деталі', value: 'name', sortable: true},
						{ text: 'Характер пошкоджень', value: 'description', sortable: true},
						{ text: 'Опис пошкодження', value: 'description', sortable: true},
						{ text: '', value: 'actions', sortable: false, width: '10%' },

						/* Код Audatex */
					]
				}
			}
		},

		file: null,
		files: [],
		images: [
			{
				title: 'Передня частина',
				src: require('@/assets/car/car-1.jpg'),
				style: "{ objectFit: 'none', objectPosition: '-50px -100px' }"
			},
			{
				title: 'Права сторона',
				src: require('@/assets/car/car-1.jpg'),
				style: "{ objectFit: 'none', objectPosition: '-50px -100px' }"
			},
			{
				title: 'Права сторона',
				src: require('@/assets/car/car-1.jpg'),
				style: "{ objectFit: 'none', objectPosition: '-50px -100px' }"
			},
		],
		/* PNG - image/png
		JPEG - image/jpeg
		WEBP - image/webp
		HEIC - image/heic
		HEIF - image/heif */

		frameWidth: 100,
		frameHeight: 100,

		promptCustom: null,
		outputHtml: '',

		snackbar: {
			visible: false,
			text: null
		},

		outlined: true,
		dense: true,

		tiretypes: [
			{id: 1, code: 'summer', name: 'літня'},
			{id: 2, code: 'winter', name: 'зимова'},
			{id: 3, code: 'allseason', name: 'всесезонна'},
		],
	}),
	
	/* props: {
		outlined:   	{ type: Boolean, default: true },
	}, */

	computed: {
		/* ...mapGetters('VehiclePark', [ 'items' ]), */

		prompt() {
			/* let 
				category = this.params?.category?.name,
				brand = this.params?.brand?.name,
				model = this.params?.model?.name,
				generation = this.params?.generation?.name,
				modification = this.params?.modification?.name,
				yearProd = this.params?.yearProd,
				driver = this.params?.driver?.name,
				fuel = this.params?.fuel?.name,
				gearbox = this.params?.gearbox?.name,
				color = this.params?.color?.name,
				state = this.params?.state?.name,
				city = this.params?.city?.name
			;

			let params = [];

			if(category) params.push(`категорія ${category}`)
			if(brand) params.push(`марка ${brand}`)
			if(model) params.push(`модель ${model}`)
			if(generation) params.push(`модель ${generation}`)
			if(modification) params.push(`модель ${modification}`)
			if(yearProd) params.push(`${yearProd} року випуску`)
			if(driver) params.push(`тип приводу ${driver}`)
			if(fuel) params.push(`тип палива ${fuel}`)
			if(gearbox) params.push(`коробка передач ${gearbox}`)
			if(color) params.push(`колір ${color}`)
			if(state) params.push(`область ${state}`)
			if(city) params.push(`місто ${city}`)

			let param = params.join(', ');

			let prompt = `Яка ринкова вартість автомобіля в Україні в доларах і гривнях з такими характеристиками: ${param}`; */

			//let contents = "Яка ринкова вартість автомобіля BMW X5 2020 року випуску в Україні в доларах";

			//console.log(this.$options.name, 'getContent','contents', contents)

			//return prompt;

			//let prompt = "Проаналізуй, що зображено на зображеннях"
			let prompt = "Проаналізуй фото транспортного засобу як експерт по оцінці і визнач марку, модель, рік випуску, реєстраційний номер, пробіг, а також середню вартість в Україні в доларах та гривнях"

			return this.promptCustom ? this.promptCustom : prompt;
		}
	},

	created() {
		
		/* this.images = []
		this.images.push({
			title: 'Передня частина',
			src: '@/assets/car/car-1.jpg'
		})

		this.images.push({
			title: 'Права сторона',
			src: '@/assets/car/car-1.jpg'
		})

		this.images.push({
			title: 'Права сторона',
			src: '@/assets/car/car-1.jpg'
		}) */


	},

	methods: {
		/* ...mapActions(['showMessage']),
		...mapActions('VehiclePark', [ 'search', 'delete' ]), */

		/* onRefresh() {
			this.loading = true
			return this.search().finally(() => (this.loading = false));
		}, */
		onClear() {
			//console.log(this.$options.name, 'onClear', 'files', this.files)

			//this.$refs.parameters.reset()
			//this.clear()
			this.files = []
		},

		onOK() {

			this.gemini(this.prompt)

			/* if(this.$refs.parameters.validate()) {
				//let text = this.getContent()
				//let text = this.getContent()
				
				this.gemini(this.prompt)
			} */
		},

		getFileUrl(file) {
			return URL.createObjectURL(file);
		},

		removeFile(file) {
			const index = this.files.indexOf(file)
			this.files.splice(index, 1);
		},

		changeFile(e) {
			//console.log(this.$options.name, 'changeFile', 'e', e)
			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						this.addFile(element)
					})
				} else {
					this.addFile(e)
				}
			}

			this.file = null
		},

		addFile(file) {
			//console.log(this.$options.name, 'addFile', 'source', source, 'file', file)
			if(file) {
				this.files.push(file)
				/* const url = URL.createObjectURL(file);
					
				this.items.push({
					source: source ? source : 'file',
					url: url,
					file: file,
					//exif: exif
				}) */
			}
		},

		...mapActions([
			'setCategories', 'setFuels', 'setColors', 'setCountries', 'setStates'
		]),

		...mapActions('VehicleEstimate', [
			'setBrands', 'setModels', 'setGenerations', 'setModifications', 'setBodystyles', 'setDrivers',
			'setGearboxes','setOptions','setCities',
		]),

		/* reset() {
			this.$refs.form.reset()
		},

		validate() {
			this.$refs.form.validate()
		}, */

		clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.item, 'model', null)
			this.setModels()
			
			this.clearGeneration()
		},

		clearGeneration () {
			this.$set(this.item, 'generation', null)
			this.setGenerations()
			
			this.clearModification()
		},

		clearYearProd() {
			this.$set(this.item, 'yearProd', null)
			this.minYear = 1900
			this.maxYear = (new Date()).getFullYear()
		},

		clearModification () {
			this.$set(this.item, 'modification', null)
			this.setModifications()
		},

		clearBodystyle () {
			this.$set(this.item, 'bodystyle', null)
			this.setBodystyles()
		},

		clearDriver () {
			this.$set(this.item, 'driver', null)
			this.setDrivers()
		},

		clearGearbox () {
			this.$set(this.item, 'gearbox', null)
			this.setGearboxes()
		},

		clearOption () {
			this.$set(this.item, 'option', null)
			this.setOptions()
		},

		clearCity () {
			this.$set(this.item, 'city', null)
			this.setCities()
		},

		// Завантаження категорій
		loadCategories(e) {
			if(this.categories.length == 0) {
				var that = this
				//loading
				axios.get('/vehicle/category').then(response => {
					that.setCategories(response.data.filter((element) => ['CAR','TRUCK'].includes(element.code)))
				}, error => {
					console.log('error', error)
				})//.finally(() => (this.isLoading = false));
			}
		},

		// Завантаження брендів
		loadBrands() {
			if(this.item?.category?.id && this.brands.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBrands(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження моделей
		loadModels() {
			if(this.item?.category?.id && this.item?.brand?.id && this.models.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand/${this.item.brand.id}/models`).then(response => {
					//console.log(that.$options.name, 'GetdModels','response.data', response.data)
					that.setModels(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження поколінь
		loadGenerations() {
			if(this.item?.model?.id && this.generations.length == 0) {
				var that = this
				axios.get(`/vehicle/model/${this.item.model.id}/generation`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGenerations(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження років виробництва
		loadYearProds() {
			//console.log(this.$options.name, 'loadYearProds','generation', this.item.generation)

			this.minYear = this.item?.generation?.yearFrom ? this.item.generation.yearFrom : 1900
			this.maxYear = this.item?.generation?.yearTo ? this.item.generation.yearTo : (new Date()).getFullYear()
		},

		// Завантаження модифікацій
		loadModifications() {
			if(this.item?.generation?.id && this.modifications.length == 0) {
				var that = this
				axios.get(`/vehicle/generation/${this.item.generation.id}/modification`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setModifications(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження типів кузова
		loadBodystyles() {
			if(this.item?.category?.id && this.bodystyles.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/bodystyle`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBodystyles(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження типів приводу
		loadDrivers() {
			if(this.item?.category?.id && this.drivers.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/driver`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setDrivers(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження типів коробок передач
		loadGearboxes() {
			if(this.item?.category?.id && this.gearboxes.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/gearbox`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGearboxes(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження опцій
		loadOptions() {
			if(this.item?.category?.id && this.options.length == 0) {
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/option`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setOptions(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження типів палива
		loadFuels() {
			if(this.fuels.length == 0) {
				var that = this
				axios.get('/vehicle/fuel').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setFuels(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження кольорів
		loadColors() {
			if(this.colors.length == 0) {
				var that = this
				axios.get('/vehicle/color').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setColors(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження країн виробників
		loadCountries() {
			if(this.countries.length == 0) {
				var that = this
				axios.get('/vehicle/country').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCountries(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження областей
		loadStates() {
			if(this.states.length == 0) {
				var that = this
				axios.get('/state').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setStates(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		// Завантаження міст
		loadCities() {
			if(this.item?.state?.id && this.states.length == 0) {
				var that = this
				axios.get(`/state/${this.item.state.id}/city`).then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCities(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},

		onCategory (item) {
			this.clearBrand()
			this.clearBodystyle()
			this.clearDriver()
			this.clearGearbox()
			this.clearOption()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearGeneration()
		},

		onGeneration (item) {
			this.clearYearProd()
			this.clearModification()
		},

		onState (item) {
			this.clearCity()
		},
	},
}
</script>